
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/skiareal",
      function () {
        return require("private-next-pages/[region]/[resort]/skiareal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/skiareal"])
      });
    }
  